import { InstitutionsApi } from "@/features/institutions/services/institutions-api";
import { InstitutionsGetRequestModel } from "@/features/institutions/services/institutions-model";

/// 金融機関一覧取得画面処理
export class InstitutionsService {
  private institutionsApi = new InstitutionsApi();

  /**
   * 金融機関一覧取得API実行
   */
  public async getInstitutions(param: InstitutionsGetRequestModel) {
    return await this.institutionsApi.getInstitutions(param);
  }
}

